import { ausStateComboboxOptions, state } from "Models/Enums";
import { useContext } from "react";
import { MotorVehicleSearchBySelector } from "./MotorVehicleSearchBySelector";
import { VinVehicleSearch, RegistrationNumberVehicleSearch } from "./MotorVehicleSearchTypes";
import { useValidation } from "Hooks/useValidation";
import { validateRego, validateVin } from "Util/StringUtils";
import ComboboxSetter from "../Combobox/ComboboxSetter";
import { ComboboxOption } from "../Combobox/Combobox";
import { TextFieldSetter } from "../TextBox/TextFieldSetter";
import { MotorVehicleDispatchContext, MotorVehicleSearchContext } from "./MotorVehicleSearchReducers";

export function MotorVehicleSearchForBusinessEntity() {
	const { data: generateMotorVehicleSearchDetail } = useContext(MotorVehicleSearchContext);
	const dispatch = useContext(MotorVehicleDispatchContext);


	const {
		motorVehicleSearchRequest,
	} = generateMotorVehicleSearchDetail;

	return (
		<>
			<MotorVehicleSearchBySelector />

			{motorVehicleSearchRequest && motorVehicleSearchRequest.searchBy === "Vin" && (
				<MotorVehicleSearchByVinSection
					searchRequestDetail={motorVehicleSearchRequest}
					setSearchRequestDetail={value => dispatch({
						type: "SetMotorVehicleSearchRequest",
						payload: { motorVehicleSearchRequest: value }
					})}
				/>
			)}
			{motorVehicleSearchRequest && motorVehicleSearchRequest.searchBy === "RegistrationNumber" && (
				<MotorVehicleSearchByRegistrationNumberSection
					searchRequestDetail={motorVehicleSearchRequest}
					setSearchRequestDetail={value => dispatch({
						type: "SetMotorVehicleSearchRequest",
						payload: { motorVehicleSearchRequest: value }
					})}
				/>
			)}
		</>
	);
}

type MotorVehicleSearchByVinSectionProps = {
	searchRequestDetail: VinVehicleSearch;
	setSearchRequestDetail: (newValue: VinVehicleSearch) => void;
}

export const MotorVehicleSearchByVinSection: React.FunctionComponent<MotorVehicleSearchByVinSectionProps> = ({
	searchRequestDetail,
	setSearchRequestDetail
}) => {

	const validation = useValidation({
		vinNumber: {
			value: searchRequestDetail.value,
			isRequired: true,
			requiredText: "VIN is required field",
			validate: item => {
				return item.assertRule(value => validateVin(value ?? ""), "Please input valid VIN number.")
			}
		}
	});

	return (
		<>
			<TextFieldSetter
				value={searchRequestDetail.value}
				setValue={newValue => setSearchRequestDetail({ ...searchRequestDetail, value: newValue })}
				label="VIN"
				placeholder="VIN"
				isRequired
				errors={validation.get("vinNumber", false)[0]} // this is a workaround to display only the first error message
			/>
		</>
	);
}

type MotorVehicleSearchByRegistrationNumberSectionProps = {
	searchRequestDetail: RegistrationNumberVehicleSearch;
	setSearchRequestDetail: (newValue: RegistrationNumberVehicleSearch) => void;
}

export const MotorVehicleSearchByRegistrationNumberSection: React.FunctionComponent<MotorVehicleSearchByRegistrationNumberSectionProps> = ({
	searchRequestDetail,
	setSearchRequestDetail
}) => {

	const validation = useValidation({
		registrationNumber: {
			value: searchRequestDetail.value,
			isRequired: true,
			requiredText: "Registration number is required",
			validate: item => {
				return item.assertRule(value => validateRego(value ?? "") || "Registration Number is invalid", "Registration Number is invalid")
			}
		},
		state: {
			value: searchRequestDetail.state,
			isRequired: true,
			requiredText: "State is required"
		}
	});

	return (
		<>
			<TextFieldSetter
				value={searchRequestDetail.value}
				setValue={newValue => setSearchRequestDetail({ ...searchRequestDetail, value: newValue })}
				label="Registration Number"
				placeholder="Registration Number"
				isRequired
				errors={validation.get("registrationNumber", false)[0]} // this is a workaround to display only the first error message
			/>
			<ComboboxSetter
				value={searchRequestDetail.state}
				setValue={(newValue: state) => setSearchRequestDetail({ ...searchRequestDetail, state: newValue })}
				options={ausStateComboboxOptions.filter(item => item.value !== "ALL") as ComboboxOption<state | undefined>[]}
				getOptionValue={item => item}
				label="State"
				placeholder="State"
				isRequired
				errors={validation.get("state", false)[0]} // this is a workaround to display only the first error message
			/>
		</>
	)
}
